.volume {
  display: flex;
  position: relative;
  flex-direction: row;
  align-items: center;
  line-height: 1em;
}

.slider {
  --slider-width-number: 100;
  --slider-width: 100%;
  --slider-height: 2px;
  --background-slider: var(--rds-accent-color);
  --background-filled-slider: rgba(255, 255, 255, 0.5);
  --thumb-width: 10px;
  --thumb-height: 10px;
  --thumb-radius: 50%;
  --thumb-background: var(--rds-accent-color);
  --thumb-border: 1px solid var(--rds-accent-color);
  --fit-thumb-in-slider: -4px;

  appearance: none;
  background: none;
  cursor: pointer;
  display: block;
  transform-origin: left;
  height: 100%;
  min-height: 50px;
  overflow: hidden;
  margin-left: 1rem;
  transition: all 100ms 500ms;
  visibility: collapse;
}

.slider:focus {
  box-shadow: none;
  outline: none;
}

/* Webkit */
.slider::-webkit-slider-runnable-track {
  background: linear-gradient(
    to right,
    var(--background-slider) 0%,
    var(--background-slider) calc(var(--progress, 0) * 100%),
    var(--background-filled-slider) calc(var(--progress, 0) * 100%),
    var(--background-filled-slider) 100%
  );
  height: var(--slider-height);
  pointer-events: none;
}

.slider::-webkit-slider-thumb {
  width: var(--thumb-width);
  height: var(--thumb-height);
  appearance: none;
  background: var(--thumb-background);
  border-radius: var(--thumb-radius);
  margin-top: var(--fit-thumb-in-slider);
  border: var(--thumb-border);
}

/* Firefox */
.slider::-moz-range-track {
  width: var(--slider-width);
  height: var(--slider-height);
  background: linear-gradient(
    to right,
    var(--background-slider) 0%,
    var(--background-slider) calc(var(--progress, 0) * 100%),
    var(--background-filled-slider) calc(var(--progress, 0) * 100%),
    var(--background-filled-slider) 100%
  );
}

.slider::-moz-range-thumb {
  width: var(--thumb-width);
  height: var(--thumb-height);
  background: var(--thumb-background);
  border-radius: var(--thumb-radius);
  border: var(--thumb-border);
  position: relative;
}

.slider::-moz-range-progress {
  height: var(--slider-height);
  background: var(--thumb-background);
  border: 0;
  margin-top: 0;
}

.slider::-moz-focus-outer {
  border: 0;
}

/* IE/Edge */
.slider::-ms-track {
  background: transparent;
  border-radius: 0;
  border: 0 transparent;
  color: transparent;
  height: var(--slider-height);
  margin-top: 0;
  width: var(--slider-width);
}

.slider::-ms-thumb {
  width: var(--thumb-width);
  height: var(--thumb-height);
  background: var(--thumb-background);
  border-radius: var(--thumb-radius);
  margin-top: 0;
  border: 0;
}

.slider::-ms-fill-lower {
  background: var(--thumb-background);
  border-radius: 0;
  height: var(--slider-height);
}

.slider::-ms-fill-upper {
  background: linear-gradient(
    to right,
    var(--background-slider) 0%,
    var(--background-slider) calc(var(--progress, 0) * 100%),
    var(--background-filled-slider) calc(var(--progress, 0) * 100%),
    var(--background-filled-slider) 100%
  );
  border-radius: 0;
}

.slider::-ms-tooltip {
  display: none;
}

/* Responsive and shown state */
@media (max-width: 1024px) {
  .slider {
    position: absolute;
    bottom: 16px;
    left: 0;
    margin-left: 0rem;
    padding: 0.25rem;
    border-radius: 8px;
    background-color: var(--rds-background-overlay-medium);
    transform: rotate(270deg) translateY(1em);
  }
}

@media (hover: none) {
  .slider {
    display: none;
  }
}

.sliderShown {
  transition: all 100ms 50ms;
  visibility: initial;
}
